import React from 'react';
import styled from 'styled-components';

import { Text, Title } from 'components';

import {
  CenterTextWrapper,
  SVGExpired,
  VerticalSpace,
} from '@brokerbay/design-components';

import { SUPPORT_EMAIL } from 'utils/constants';

export const PortalExpiredView = () => {
  const SVGExpiredStyled = styled(SVGExpired)`
    width: 100%;
  `;

  return (
    <VerticalSpace>
      <SVGExpiredStyled />

      <Title textAlign="center" level={1} data-cy="title-expired-portal">
        Your onboarding link has expired.
      </Title>

      <CenterTextWrapper>
        <Text>
          Please reach out to{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> to reactivate
          the link.
        </Text>
      </CenterTextWrapper>
    </VerticalSpace>
  );
};
